export const agency = {
  // Main page titles
  agencyDashboard: 'Tableau de Bord',
  dashboardDescription: 'Surveillez les performances et les métriques clés de votre entreprise de location',
  bookingsManagement: 'Réservations',
  bookingsPageDescription: 'Gérer toutes vos réservations de location et les réservations des clients',
  newBooking: 'Nouvelle Réservation',
  editBooking: 'Modifier la Réservation',
  totalBookings: '{{count}} réservations',
  
  // Traductions racine pour BookingModal (seulement les uniques)
  selectCarFirst: 'Sélectionnez d\'abord un véhicule',
  selectDateFirst: 'Sélectionnez d\'abord une date',
  locationsAvailable: 'emplacements disponibles',
  carNoLocation: 'Ce véhicule n\'a pas d\'emplacement assigné',
  additionalNotesPlaceholder: 'Ajoutez des notes supplémentaires ou des exigences spéciales...',
  
  // Clés racine pour le modal client
  cin: 'CIN',
  
  // Clés racine pour les boutons du modal de réservation
  createBooking: 'Créer la Réservation',
  cancel: 'Annuler',
  
  // Dashboard setup and overview
  vehiclePlanning: 'Planification et Programmation de Flotte',
  welcomeToAgency: 'Bienvenue dans votre Agence de Location',
  addFirstVehicleMessage: 'Commencez par construire votre flotte de véhicules',
  addFirstVehicle: 'Ajouter votre Premier Véhicule',
  setupStep1: 'Construisez votre Flotte',
  setupStep1Desc: 'Ajoutez des véhicules avec des détails complets, tarifs et disponibilité',
  setupStep2: 'Gérez votre Base Clients',
  setupStep2Desc: 'Créez et organisez vos profils clients et historique de location',
  setupStep3: 'Suivez les Opérations de Location',
  setupStep3Desc: 'Surveillez les réservations actives, plannings et performances de location',
  statisticsAnalytics: 'Analyses Commerciales et Insights',
  
  // Agency Setup
  agencySetup: {
    setupRequired: 'Configuration requise',
  },
  
  // Locations
  locations: {
    title: 'Emplacements de l\'agence',
    description: 'Gérez les lieux où vos véhicules peuvent être récupérés et rendus',
    addLocation: 'Ajouter un emplacement',
    addNewLocation: 'Ajouter un nouvel emplacement',
    editLocation: 'Modifier l\'emplacement',
    searchLocation: 'Rechercher un emplacement',
    searchPlaceholder: 'Rechercher aéroports, gares, centres-villes...',
    searchHelp: 'Recherchez des emplacements populaires ou ajoutez votre propre emplacement personnalisé',
    name: 'Nom de l\'emplacement',
    namePlaceholder: 'Parking Principal, Bureau, etc.',
    city: 'Ville',
    cityPlaceholder: 'Casablanca',
    address: 'Adresse',
    addressPlaceholder: 'Adresse complète de l\'emplacement',
    setAsDefault: 'Définir comme emplacement par défaut',
    defaultLocationUpdated: 'Lieu principal mis à jour avec succès',
    locationDeleted: 'Emplacement supprimé avec succès',
    deleteConfirmTitle: 'Supprimer l\'emplacement',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer l\'emplacement',
    deleteConfirmWarning: 'Cette action ne peut pas être annulée.',
    noLocations: 'Aucun emplacement configuré',
    noLocationsDesc: 'Ajoutez au moins un emplacement pour commencer à gérer vos véhicules',
    addFirstLocation: 'Ajouter le premier emplacement',
    default: 'Principal',
    selectLocation: 'Sélectionner un lieu',
    noLocationsAvailable: 'Aucun lieu disponible',
    pickupLocation: 'Lieu de prise en charge',
    returnLocation: 'Lieu de retour',
    selectPickupLocation: 'Sélectionner le lieu de prise en charge',
    selectReturnLocation: 'Sélectionner le lieu de retour',
    selectPickupLocationError: 'Veuillez sélectionner un lieu de prise en charge',
    selectReturnLocationError: 'Veuillez sélectionner un lieu de retour',
  },

  // Vehicle Management
  vehicles: {
    title: 'Véhicules',
    subtitle: 'Gérez votre flotte de véhicules',
    addVehicle: 'Ajouter un Véhicule',
    editVehicle: 'Modifier le Véhicule',
    addFirstVehicle: 'Ajoutez Votre Premier Véhicule',
    noVehicles: 'Aucun Véhicule Trouvé',
    noVehiclesDesc: 'Commencez par ajouter des véhicules à votre flotte.',
    totalVehicles: '{{count}} véhicules trouvés',
    searchPlaceholder: 'Rechercher des véhicules...',
    
    // Vehicle fields
    make: 'Marque',
    model: 'Modèle',
    year: 'Année',
    color: 'Couleur',
    seats: 'Sièges',
    transmission: 'Transmission',
    fuelType: 'Type de Carburant',
    pricePerDay: 'Prix par Jour',
    description: 'Description',
    category: 'Catégorie',
    selectCategory: 'Sélectionner une Catégorie',
    location: 'Emplacement du Véhicule',
    selectLocation: 'Sélectionner un emplacement',
    locationRequired: 'Veuillez sélectionner un emplacement',
    primaryLocationRequired: 'Chaque véhicule doit avoir au moins une agence principale',
    registrationNumber: 'Numéro d\'Immatriculation',
    currentMileage: 'Kilométrage Actuel',
    insuranceExpiryDate: 'Date d\'Expiration de l\'Assurance',
    technicalControlExpiryDate: 'Date d\'Expiration du Contrôle Technique',
    circulationPermitExpiryDate: 'Date d\'Expiration du Permis de Circulation',
    lastOilChangeDate: 'Date de la Dernière Vidange',
    lastOilChangeMileage: 'Kilométrage de la Dernière Vidange',
    oilChangeIntervalKm: 'Intervalle de Vidange (km)',
    maintenanceNotes: 'Notes de Maintenance',
    features: 'Caractéristiques',
    images: 'Images',
    
    // Placeholders
    enterMake: 'Entrez la marque du véhicule',
    enterModel: 'Entrez le modèle du véhicule',
    enterColor: 'Entrez la couleur du véhicule',
    enterDescription: 'Entrez la description du véhicule',
    enterRegistrationNumber: 'Entrez le numéro d\'immatriculation',
    enterMaintenanceNotes: 'Entrez les notes de maintenance',
    
    // Actions
    edit: 'Modifier',
    delete: 'Supprimer',
    deleteAll: 'Supprimer Tout',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce véhicule ?',
    deleteConfirmTitle: 'Supprimer le Véhicule',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce véhicule ? Cette action ne peut pas être annulée.',
    deleteAllConfirmTitle: 'Supprimer les Véhicules Sélectionnés',
    deleteAllConfirmMessage: 'Êtes-vous sûr de vouloir supprimer {{count}} véhicules sélectionnés ? Cette action ne peut pas être annulée.',
    cancel: 'Annuler',
    
    // Status (includes both vehicle and booking statuses for compatibility)
    status: {
      available: 'Disponible',
      rented: 'Loué',
      maintenance: 'Maintenance',
      pending: 'En Attente',
      confirmed: 'Confirmé',
      completed: 'Terminé',
      cancelled: 'Annulé'
    },
    
    // Transmission types
    transmissionType: {
      automatic: 'Automatique',
      manual: 'Manuelle',
    },
    
    // Fuel types
    fuelTypes: {
      gasoline: 'Essence',
      diesel: 'Diesel',
      hybrid: 'Hybride',
      electric: 'Électrique',
    },
    
    // Categories
    categories: {
      economy: 'Économique',
      compact: 'Compacte',
      midsize: 'Intermédiaire',
      fullsize: 'Grande Taille',
      luxury: 'Luxe',
      suv: 'SUV',
    },
    
    // Image upload
    uploadImages: 'Télécharger des Images',
    maxImages: 'Maximum 6 images',
    dragDropImages: 'Glissez-déposez les images ici ou cliquez pour sélectionner',
    dragToReorder: 'Glissez les images pour les réorganiser. La première image sera la photo principale.',
    removeImage: 'Supprimer l\'image',
    
    // Features
    addFeature: 'Ajouter une Caractéristique',
    removeFeature: 'Supprimer la caractéristique',
    enterFeature: 'Entrez le nom de la caractéristique',
    suggestedFeatures: 'Caractéristiques Suggérées',
    addAllFeatures: 'Ajouter Tout',
    removeAllFeatures: 'Supprimer Tout',
    
    // Validation messages
    makeRequired: 'La marque est obligatoire',
    modelRequired: 'Le modèle est obligatoire',
    yearRequired: 'L\'année est obligatoire',
    colorRequired: 'La couleur est obligatoire',
    categoryRequired: 'La catégorie est obligatoire',
    transmissionRequired: 'La transmission est obligatoire',
    fuelTypeRequired: 'Le type de carburant est obligatoire',
    priceRequired: 'Le prix par jour est obligatoire',
    seatsRequired: 'Le nombre de sièges est obligatoire',
    
    // Success messages
    vehicleAdded: 'Véhicule ajouté avec succès',
    vehicleUpdated: 'Véhicule mis à jour avec succès',
    vehicleDeleted: 'Véhicule supprimé avec succès',
    vehiclesDeleted: '{{count}} véhicules supprimés avec succès',
    
    // Error messages
    failedToAdd: 'Échec de l\'ajout du véhicule. Veuillez réessayer.',
    failedToUpdate: 'Échec de la mise à jour du véhicule. Veuillez réessayer.',
    failedToDelete: 'Échec de la suppression du véhicule. Veuillez réessayer.',
    failedToUpload: 'Échec du téléchargement de l\'image. Veuillez réessayer.',
    
    // Bulk actions
    bulkActions: 'Actions en Lot',
    selectAll: 'Tout Sélectionner',
    selectedCount: '{{count}} sélectionné(s)',
    markAsAvailable: 'Marquer comme Disponible',
    markAsRented: 'Marquer comme Loué',
    markAsMaintenance: 'Marquer comme Maintenance',
    exportSelected: 'Exporter la Sélection',
    
    // Table columns
    image: 'Image',
    availability: 'Disponibilité',
    actions: 'Actions',
    createdAt: 'Créé',
    updatedAt: 'Mis à jour',
    
    // Form sections
    basicInformation: 'Informations de Base',
    specifications: 'Spécifications',
    pricing: 'Tarification',
    maintenanceInfo: 'Informations de Maintenance',
    additionalFeatures: 'Caractéristiques Supplémentaires',
    
    // Clear form
    clearForm: 'Effacer le Formulaire',
    clearFormConfirm: 'Êtes-vous sûr de vouloir effacer toutes les données du formulaire ?',
    
    // Additional validation messages
    yearInvalid: 'L\'année doit être entre 1900 et 2030',
    seatsInvalid: 'Le nombre de sièges doit être entre 1 et 15',
    registrationInvalid: 'Le numéro d\'immatriculation doit contenir plus de 3 caractères',
    mileageInvalid: 'Le kilométrage ne peut pas être négatif',
    oilChangeMileageInvalid: 'Le kilométrage de vidange ne peut pas être négatif',
    oilChangeIntervalInvalid: 'L\'intervalle de vidange doit être d\'au moins 1000 km',
    oilChangeDateInvalid: 'La date de dernière vidange ne peut pas être dans le futur',
    
    // Error messages
    permissionDenied: 'Permission refusée. Assurez-vous d\'avoir accès à la gestion des véhicules pour cette agence.',
    invalidData: 'Données invalides fournies. Veuillez vérifier tous les champs requis.',
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion internet et réessayer.',
    
    // Search placeholders
    searchBrand: 'Tapez pour rechercher une marque...',
    selectModel: 'Sélectionnez un modèle...',
    selectBrandFirst: 'Sélectionnez d\'abord une marque',
    searchColor: 'Tapez pour rechercher une couleur...',
    
    // Vehicle features
    featuresList: {
      airConditioning: 'Climatisation',
      powerSteering: 'Direction assistée',
      centralLocking: 'Verrouillage centralisé',
      electricWindows: 'Vitres électriques',
      radio: 'Radio',
      gpsNavigation: 'GPS/Navigation',
      bluetooth: 'Bluetooth',
      backupCamera: 'Caméra de recul',
      parkingSensors: 'Capteurs de stationnement',
      heatedSeats: 'Sièges chauffants',
      sunroof: 'Toit ouvrant',
      alloyWheels: 'Jantes alliage',
      ledHeadlights: 'Phares LED',
      cruiseControl: 'Régulateur de vitesse',
      premiumAudio: 'Système audio premium',
      usbAux: 'USB/AUX',
      keylessStart: 'Démarrage sans clé',
      sideAirbags: 'Airbags latéraux',
      abs: 'ABS',
      esp: 'ESP',
      brakeAssist: 'Assistance au freinage',
      blindSpotDetection: 'Détection angle mort',
      laneAssist: 'Alerte de franchissement',
      heatedWindshield: 'Pare-brise chauffant',
      electricMirrors: 'Rétroviseurs électriques',
    },
  },

  // Client Management
  clients: {
    title: 'Gestion des Clients',
    subtitle: 'Gérez vos clients et leur historique de location',
    addCustomer: 'Ajouter un Client',
    addNewCustomer: 'Ajouter un Nouveau Client',
    noClients: 'Aucun Client Trouvé',
    noClientsDesc: 'Les clients apparaîtront ici lorsqu\'ils feront des réservations.',
    totalClients: '{{count}} client(s) trouvé(s)',
    searchPlaceholder: 'Rechercher par nom, email, téléphone ou CIN...',
    selectedClients: '{{count}} sélectionné(s)',
    
    // Table headers
    client: 'Client',
    phone: 'Téléphone',
    type: 'Type',
    bookings: 'Réservations',
    spent: 'Dépensé',
    actions: 'Actions',
    cin: 'CIN',
    viewCinImage: 'Voir l\'Image CIN',
    
    // Client types
    individual: 'Particulier',
    company: 'Entreprise',
    personalCustomerAccount: 'Compte client personnel',
    businessCustomerAccount: 'Compte client professionnel',
    
    // Add customer modal
    selectAccountType: 'Sélectionner le Type de Compte',
    chooseAccountTypeDesc: 'Choisissez le type de compte client que vous souhaitez créer',
    stepOfTwo: 'Étape {{step}} sur 2',
    requiresCIN: 'Requis : CIN, Permis de Conduire',
    requiresICE: 'Requis : Numéro ICE',
    
    // Form fields
    fullName: 'Nom Complet',
    companyName: 'Nom de l\'Entreprise',
    phoneNumber: 'Numéro de Téléphone',
    identityCardNumber: 'Numéro de Carte d\'Identité (CIN)',
    drivingPermitNumber: 'Numéro de Permis de Conduire',
    iceNumber: 'Numéro ICE',
    clientType: 'Type de Client',
    
    // Placeholders
    enterFullName: 'Entrez le nom complet du client',
    enterCompanyName: 'Entrez le nom de l\'entreprise',
    enterPhone: 'Entrez le téléphone du client',
    enterCompanyPhone: 'Entrez le téléphone de l\'entreprise',
    enterCIN: 'Entrez le numéro CIN',
    enterPassportNumber: 'Entrez le numéro de passeport',
    enterResidencePermitNumber: 'Entrez le numéro de carte de séjour',
    enterDrivingPermitNumber: 'Entrez le numéro de permis de conduire (optionnel)',
    filterByRegistrationPeriod: 'Filtrer par période d\'inscription',
    passport: 'Passeport',
    enterPassport: 'Entrez le numéro de passeport',
    enterResidencePermit: 'Entrez le numéro de carte de séjour',
    enterDrivingPermit: 'Entrez le numéro de permis de conduire',
    enterICE: 'Entrez le numéro ICE (15 chiffres)',
    
    // Client details modal
    clientDetails: 'Détails du Client',
    personalInformation: 'Informations Personnelles',
    joinedDate: 'Date d\'Inscription',
    totalBookings: 'Total Réservations',
    totalSpent: 'Total Dépensé',
    averageRating: 'Note Moyenne',
    recentBookings: 'Réservations Récentes',
    clientDocument: 'Document Client',
    identityDocument: 'Pièce d\'Identité',
    downloadPDF: 'Télécharger Contrat + Pièce d\'Identité',
    noImage: 'Aucune image',
    noIdentityDocument: 'Aucun document d\'identité disponible',
    noBookings: 'Aucune réservation encore',
    
    // Edit client
    editClient: 'Modifier le Client',
    
    // Buttons and actions
    cancel: 'Annuler',
    save: 'Enregistrer',
    update: 'Mettre à jour',
    viewDetails: 'Voir les Détails',
    
    // Status messages
    customerAdded: 'Client ajouté avec succès',
    customerUpdated: 'Client mis à jour avec succès',
    failedToAdd: 'Échec de l\'ajout du client. Veuillez réessayer.',
    failedToUpdate: 'Échec de la mise à jour du client. Veuillez réessayer.',
    
    // Validation messages
    fullNameRequired: 'Le nom complet est requis',
    phoneRequired: 'Le numéro de téléphone est requis',
    clientTypeRequired: 'Le type de client est requis',
    cinRequired: 'Le CIN est requis pour les particuliers',
    drivingPermitRequired: 'Le numéro de permis de conduire est requis pour les particuliers',
    iceRequired: 'Le numéro ICE est requis pour les entreprises',
    iceInvalid: 'Le numéro ICE doit contenir exactement 15 chiffres',
    
    // Traductions des documents d'identité
    carteSejourShort: 'Carte Séjour',
    selectOneIdentityDocument: 'Veuillez sélectionner un seul document d\'identité',
  },

  // Réservations
  bookings: {
    title: 'Réservations',
    subtitle: 'Gérer vos réservations de location',
    searchBookings: 'Rechercher par nom client, véhicule, ou référence de réservation...',
    periodLabel: 'Période',
      filterByPeriodPlaceholder: 'Filtrer par période',
  allPeriod: 'Toutes les périodes',
  activePeriod: 'Période Active',
    activeFilters: 'Filtres Actifs',
    clearAllFilters: 'Tout Effacer',
    searchLabel: 'Recherche',
    statusLabel: 'Statut de Réservation',
    vehicleLabel: 'Véhicule',
    noBookingsFound: 'Aucune réservation trouvée',
    noBookings: 'Aucune réservation encore',
    tryDifferentFilter: 'Essayez d\'ajuster vos filtres',
    noBookingsDesc: 'Les réservations apparaîtront ici lorsque les clients feront des réservations.',
    createFirstBooking: 'Créer Première Réservation',
    totalBookings: '{{count}} réservation(s) trouvée(s)',
    bookingDetails: 'Détails de Réservation',
    clientInformation: 'Informations Client',
    vehicleInformation: 'Informations Véhicule',
    rentalPeriod: 'Période de Location',
    pricing: 'Tarification',
    startDate: 'Date de Début',
    endDate: 'Date de Fin',
    extensible: 'Extensible',
    startDateHeader: 'Date Début',
    endDateHeader: 'Date Fin',
    pickupTime: 'Heure de Prise',
    returnTime: 'Heure de Retour',
    pickupTimeHeader: 'Heure Prise',
    returnTimeHeader: 'Heure Retour',
    totalPrice: 'Prix Total',
    deposit: 'Dépôt',
    duration: 'Durée',
    drivingLicense: 'Permis de Conduire',
    contract: 'Contrat',
    bookingStatus: 'Statut de réservation',
    invoiceStatus: 'Statut de facture',
    contractActions: 'Actions de contrat',
    downloadInvoice: 'Télécharger facture',
    delete: 'Supprimer',
    cancel: 'Annuler',
    edit: 'Modifier',
    actions: 'Actions',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette réservation?',
    deleteConfirmTitle: 'Supprimer la Réservation',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette réservation? Cette action ne peut pas être annulée.',
    deleteSuccess: 'Réservation supprimée avec succès',
    deleteError: 'Échec de la suppression de la réservation',
    createSuccess: 'Réservation créée avec succès',
    updateSuccess: 'Réservation mise à jour avec succès',
    saveError: 'Erreur lors de la sauvegarde',
    statusUpdated: 'Statut mis à jour avec succès',
    days: 'jours',
    customer: 'Client',
    driver: 'Conducteur',
    vehicle: 'Véhicule',
    dates: 'Dates',
    pickupLocation: 'Lieu de Prise',
    returnLocation: 'Lieu de Retour',
    allStatuses: 'Tous les Statuts',
    selectVehiclePlaceholder: 'Sélectionner un véhicule...',
    columns: 'Colonnes',
    customizeColumns: 'Personnaliser Colonnes',
    resetColumns: 'Réinitialiser',
    bookingInformation: 'Informations de Réservation',
    financialInformation: 'Informations Financières',
    additionalInformation: 'Informations Supplémentaires',
    depositAmount: 'Montant du Dépôt',
    bankGuarantee: 'Caution / Damana Bankiya',
    damageAmount: 'Frais de Dommage',
    notes: 'Notes',
    createdAt: 'Créé le',
    status: {
      pending: 'En Attente',
      confirmed: 'Confirmé',
      completed: 'Terminé',
      cancelled: 'Annulé'
    },
    
    // Booking modal translations
    searchCustomer: 'Rechercher par nom ou CIN...',
    createNewCustomer: 'Créer un Nouveau Client',
    individual: 'Particulier',
    company: 'Entreprise',
    noCustomerFound: 'Aucun client trouvé',
    noCustomersYet: 'Aucun client n\'a été ajouté encore',
    addFirstCustomer: 'Ajouter le Premier Client',
    selectVehicle: 'Sélectionner un Véhicule',
    selectDatePlaceholder: 'Sélectionner une date',
    timePlaceholder: 'Sélectionner l\'heure',
    selectClientError: 'Veuillez sélectionner un client',
    selectVehicleError: 'Veuillez sélectionner un véhicule',
    selectDatesError: 'Veuillez sélectionner les dates',
    selectDateRange: 'Sélectionnez une période pour calculer le prix',
    totalPriceError: 'Le prix total doit être supérieur à 0',
    
    // Secondary driver translations
    secondaryDriver: 'Conducteur Secondaire',
    optional: 'Optionnel',
    noSecondaryDriver: 'Aucun conducteur secondaire',
    searchSecondaryDriver: 'Rechercher un conducteur secondaire...',
    addSecondaryDriver: 'Ajouter Conducteur Secondaire',
    createNewSecondaryDriver: 'Créer un Nouveau Conducteur Secondaire',
    clearSecondaryDriver: 'Effacer',
    noCustomersForSecondaryDriver: 'Aucun client disponible pour conducteur secondaire',
    noSecondaryDriverFound: 'Aucun conducteur secondaire trouvé',
    secondaryDriverAdded: 'Conducteur secondaire ajouté avec succès',
    errorAddingSecondaryDriver: 'Erreur lors de l\'ajout du conducteur secondaire',
    
    // Payment status for new bookings
    paymentStatus: 'État de Paiement',
    paymentStatusDescription: 'Choisir l\'état de paiement pour la nouvelle réservation - sera appliqué automatiquement à la facture',
    paymentOptions: {
      paid: 'Payé Intégralement',
      partial_paid: 'Partiellement Payé'  
    },

    // Additional keys for booking modal
    save: 'Enregistrer',
    createBooking: 'Créer la Réservation',
    
    // Booking details and form labels
    pickupTimeLabel: 'Heure de prise en charge',
    returnTimeLabel: 'Heure de retour',
    pickupLocationLabel: 'Lieu de prise en charge',
    returnLocationLabel: 'Lieu de retour',
    pickupLocationPlaceholder: 'Lieu de prise en charge',
    returnLocationPlaceholder: 'Lieu de retour',
    totalPricePlaceholder: 'Prix total',
    depositAmountPlaceholder: 'Montant de l\'acompte',
    pricePerDay: 'Prix par jour',
    notesPlaceholder: 'Ajouter des notes...',
    noNotes: 'Aucune note',
    agency: 'Agence',
    notSpecified: 'Non spécifiée',
    paid: 'Payé',
    pending: 'En attente',
    failed: 'Échec',
    refunded: 'Remboursé',
    
    // Customer management in booking modal
    addNewCustomer: 'Ajouter un Nouveau Client',
    selectAccountType: 'Sélectionner le Type de Compte',
    chooseAccountTypeDesc: 'Choisissez le type de compte client que vous souhaitez créer',
    personalCustomerAccount: 'Compte client personnel',
    businessCustomerAccount: 'Compte client professionnel',
    fullName: 'Nom Complet',
    phoneNumber: 'Numéro de Téléphone',
    identityCardNumber: 'Numéro de Carte d\'Identité (CIN)',
    residencePermit: 'Carte Séjour (Permis de Séjour)',
    passportNumber: 'Numéro de Passeport',
    drivingLicenseNumber: 'Numéro de Permis de Conduire',
    iceNumber: 'Numéro ICE',
    back: 'Retour',
    stepOf: 'Étape {{current}} sur {{total}}',
    enterCompanyName: 'Entrer le nom de l\'entreprise',
    enterClientFullName: 'Entrer le nom complet du client',
    enterCompanyPhone: 'Entrer le téléphone de l\'entreprise',
    enterClientPhone: 'Entrer le téléphone du client',
    enterCinNumber: 'Entrer le numéro CIN',
    enterDrivingPermitNumber: 'Entrer le numéro de permis de conduire',
    enterIceNumber: '15 chiffres',
    adding: 'Ajout...',
    addClient: 'Ajouter le Client',
    
    // Error messages
    cannotSelectDateRange: 'Impossible de sélectionner cette plage de dates car elle contient des jours déjà réservés pour ce véhicule.',
    selectPickupLocationError: 'Veuillez sélectionner un lieu de prise en charge',
    selectReturnLocationError: 'Veuillez sélectionner un lieu de retour',
    carAvailableFrom: 'La voiture sera disponible à partir de',
    completedBookingTooltip: 'Les réservations terminées ne peuvent pas être modifiées',
    allBookingsCount: 'Toutes les réservations (en attente, confirmées, terminées)',
    completedBookingsOnly: 'Basé uniquement sur les réservations terminées',
    completedAndConfirmedBookings: 'Basé sur les réservations terminées et confirmées',
    filterByStatus: 'Filtrer par statut de réservation :',
    
    // Read-only mode
    readOnlyInEditMode: 'Lecture seule en mode édition',
  },

  // Dashboard charts and stats
  charts: {
    available: 'Disponibles',
    rented: 'Occupés',
    vehicleStats: 'Statistiques des Véhicules',
    availableVehicles: 'Véhicules disponibles',
    pendingReservations: 'Réservations en attente'
  },

  // Contracts integration in bookings
  contracts: {
    generateContract: 'Générer le Contrat',
    viewContract: 'Voir le Contrat',
    downloadContract: 'Télécharger le Contrat',
    contractGenerated: 'Contrat Généré',
    noContract: 'Aucun Contrat',
    contractNumber: 'Contrat n°{{number}}',
    generatedOn: 'Généré le {{date}}',
    contractExists: 'Le contrat existe déjà pour cette réservation',
    generateNewContract: 'Générer un Nouveau Contrat',
    regenerateContract: 'Régénérer le Contrat',
    contractGeneratedSuccessfully: 'Contrat généré avec succès',
    failedToGenerateContract: 'Échec de la génération du contrat',
    termsAndConditions: 'Conditions Générales',
    defaultTerms: `1. Le locataire doit présenter un permis de conduire valide et une pièce d'identité.
2. Le véhicule doit être restitué dans le même état qu'il a été remis.
3. Tout dommage au véhicule sera facturé au locataire.
4. Le locataire est responsable de toutes les infractions au code de la route pendant la période de location.
5. Il est strictement interdit de fumer dans le véhicule.
6. Le véhicule doit être restitué avec le même niveau de carburant que celui fourni.
7. Un retard dans la restitution entraînera des frais supplémentaires.
8. La caution sera remboursée lors de la restitution satisfaisante du véhicule.`,
    rentalAgreement: 'Contrat de Location',
    contractPreview: 'Aperçu du Contrat',
    clientSignature: 'Signature du Client',
    agencySignature: 'Signature de l\'Agence',
    signedContract: 'Signé',
    pendingSignature: 'En attente',
    totalAmount: 'Montant Total',
    depositAmount: 'Montant de la Caution',
    rentalPeriod: 'Période de Location',
    vehicleInformation: 'Informations du Véhicule',
    clientInformation: 'Informations du Client',
    contractStatus: 'Statut du Contrat',
    signatureDate: 'Date de Signature',
    contractActions: 'Actions du Contrat',
    contractDetails: 'Détails du Contrat',
    printContract: 'Imprimer le Contrat',
    emailContract: 'Envoyer le Contrat par Email',
    contractSent: 'Contrat envoyé avec succès',
    contractNotFound: 'Contrat introuvable',
    contractPreviewTitle: 'Aperçu du Contrat - {{contractNumber}}',
    contractInformation: 'Informations du Contrat',
    createdAt: 'Créé le',
    template: 'Modèle',
    enterTerms: 'Saisir les conditions générales...',
    downloadPdf: 'Télécharger PDF',
    print: 'Imprimer',
    emailToClient: 'Envoyer au Client',
    showPreview: 'Afficher l\'Aperçu',
    hidePreview: 'Masquer l\'Aperçu',
  },

  invoices: {
    title: "Factures",
    invoice: "Facture",
    invoiceNumber: "Numéro de facture",
    totalAmount: "Montant total",
    status: {
      draft: "Brouillon",
      paid: "Payé",
      partial_paid: "Partiellement Payé",
      canceled: "Annulé",
      sent: "Envoyé",
      overdue: "En retard"
    },
    invoiceError: "Erreur lors de la génération de la facture",
    statusUpdateError: "Erreur lors de la mise à jour du statut de la facture",
    paidInvoiceProtection: "Les factures payées ne peuvent pas être modifiées",
    lockedInvoiceProtection: "Les factures payées et annulées ne peuvent pas être modifiées",
    invoiceLockedTooltip: "Les factures payées et annulées ne peuvent pas être modifiées"
  },

  // Dashboard specific translations (moved from dashboard namespace)
  noCarsYet: 'Aucun véhicule pour le moment',
  noCarsYetDesc: 'Vous n\'avez pas encore ajouté de véhicules à votre flotte. Ajoutez votre premier véhicule pour commencer à gérer votre entreprise de location.',
  detailedAnalysis: 'Analyse détaillée de vos performances et indicateurs clés',
  vehicleStatus: 'État des véhicules',
  categoryPerformance: 'Performance par catégorie',
  
  // Dashboard cards and chart labels
  reservations: 'Réservations',
  revenue: 'Revenus',
  revenueEvolution: 'Évolution des revenus (6 derniers mois)',
  lastReservations: 'Dernières Réservations',
  revenueMad: 'Revenus (MAD)',
  monthlyRevenue: 'Revenus Mensuels',
  performanceIndicators: 'Indicateurs de performance',
  occupancyRate: 'Taux d\'occupation',
  cancellationRate: 'Taux d\'annulation',
  customerSatisfaction: 'Satisfaction client',
  activeVehicles: 'Véhicules actifs',
  availableVehicles: 'Véhicules disponibles',
  revenueThisMonth: 'Revenus ce mois',
  payments: 'Paiements',
  completed: 'Complétés',
  averageDuration: 'Durée moyenne',
  perRental: 'Par location',
  days: 'jours',
  outOf: 'sur',
  total: 'total',
  
  // Tab labels
  all: 'Toutes',
  confirmed: 'Confirmées',
  
  // Status translations
  confirmedBookings: 'Confirmées',
  pendingBookings: 'En attente',
  completedBookings: 'Terminées',
  cancelledBookings: 'Annulées',
  
  // Messages
  noRecentReservations: 'Aucune réservation récente',
  noConfirmedReservations: 'Aucune réservation confirmée',
  noPendingReservations: 'Aucune réservation en attente',
  createdOn: 'Créé le',
  unknownDate: 'Date inconnue',
  viewAll: 'Voir tout',
  
  // Chart configuration labels
  chartLabels: {
    vehicles: 'Véhicules',
    bookings: 'Réservations',
    revenue: 'Revenus',
    performance: 'Performance',
    maintenance: 'Maintenance',
  },
  
  // Performance metrics
  performanceMetrics: {
    occupancyRate: 'Taux d\'occupation',
    customerSatisfaction: 'Satisfaction client',
    cancellationRate: 'Taux d\'annulation',
  },
  
  // Financial labels
  averagePerBooking: 'Moy. par réservation',
  
  // Edit booking modal labels (unique ones only)
  modify: 'Modifier',
  saving: 'Sauvegarde...',
  saveChanges: 'Sauvegarder',
  customerInformation: 'Informations client',
  bookingDetails: 'Détails de la réservation',
  fullName: 'Nom complet',
  email: 'Email',
  phone: 'Téléphone',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  duration: 'Durée',
  pricePerDay: 'Prix par jour',
  
  // Status options for booking modal
  statusOptions: {
    pending: 'En attente',
    confirmed: 'Confirmée',
    completed: 'Terminée',
    cancelled: 'Annulée',
  },

  // Root level translations needed by BookingSystem  
  columns: 'Colonnes',
  customizeColumns: 'Personnaliser les colonnes',
  resetColumns: 'Réinitialiser les colonnes',
  bookingInformation: 'Informations de réservation',
  additionalInformation: 'Informations supplémentaires',
  financialInformation: 'Informations financières',
  customer: 'Client',
  car: 'Voiture',
  vehicle: 'Véhicule',
  dates: 'Dates',
  pickupLocation: 'Lieu de prise en charge',
  returnLocation: 'Lieu de retour',
  pickupTime: 'Heure de prise en charge',
  returnTime: 'Heure de retour',
  totalPrice: 'Prix total',
  contract: 'Contrat',
  actions: 'Actions',
  notes: 'Notes',
  createdAt: 'Créé le',
  depositAmount: 'Montant de l\'acompte',
  damageAmount: 'Montant des dommages',
  searchBookings: 'Rechercher des réservations',
  allStatuses: 'Tous les statuts',
  periodLabel: 'Période',
  selectVehiclePlaceholder: 'Sélectionner un véhicule...',
  filterByPeriodPlaceholder: 'Filtrer par période...',
  allPeriod: 'Toutes les périodes',
  activeFilters: 'Filtres actifs',
  clearAllFilters: 'Effacer tous les filtres',
  searchLabel: 'Recherche',
  vehicleLabel: 'Véhicule',
  
  // Status translations
  status: {
    pending: 'En attente',
    confirmed: 'Confirmée',
    completed: 'Terminée',
    cancelled: 'Annulée',
  },

  // Calendar component translations
  today: 'Aujourd\'hui',
  todayShort: 'Auj.',
  thisWeek: 'Cette Semaine',
  clientsLabel: 'Clients',
  legend: 'Légende',
  confirmedShort: 'Conf',
  pendingShort: 'Att',
  completedShort: 'Term',
  cancelledShort: 'Ann',
  searchVehicleOrClient: 'Rechercher véhicule ou client...',
  unknownClient: 'Client inconnu',
  notAvailable: 'Non disponible',
  viewCalendar: 'Voir le Calendrier',
  
  // Calendar namespace
  calendar: {
    title: 'Planification des véhicules',
  },
  
  // Common namespace for cross-component usage
  common: {
    vehicles: 'Véhicules',
  },
  
  // Reports Section
  reports: {
    title: 'Rapports et analyses',
    subtitle: 'Consultez les métriques de performance de votre agence',
    topCarsByBookings: 'Top véhicules par réservations',
    topCarsByRevenue: 'Top véhicules par revenus',
    topClientsByPaid: 'Top clients par montant payé',
    topClientsByReservations: 'Top clients par réservations',
    bookings: 'réservations',
    reservations: 'réservations',
    noData: 'Aucune donnée disponible',
    allBookingsCount: 'Toutes les réservations (en attente, confirmées, terminées)',
    completedAndConfirmedBookings: 'Basé sur les réservations terminées et confirmées',
    filterByStatus: 'Filtrer par statut de réservation:',
    showingStatusTypes: 'Affichage',
    noStatusSelected: 'Aucun statut sélectionné - veuillez sélectionner au moins un statut pour voir les données',
    pleaseSelectStatus: 'Veuillez sélectionner au moins un statut de réservation pour voir les données',
  },

  // Settings translations
  settings: {
    // Tab names
    general: 'Général',
    locations: 'Emplacements',
    business: 'Entreprise',
    notifications: 'Notifications',
    
    // Main settings
    title: 'Paramètres de l\'Agence',
    subtitle: 'Configurez votre profil d\'agence et vos préférences',
    settingsDescription: 'Gérez vos paramètres d\'agence, horaires de travail et préférences de notification.',
    
    // Agency Information
    agencyInformation: 'Informations de l\'Agence',
    agencyInformationDesc: 'Informations de base sur votre agence de location de voitures',
    agencyLogo: 'Logo de l\'Agence',
    logoRecommendation: 'Téléchargez le logo de votre agence (taille recommandée : 200x200px)',
    
    // Financial Settings
    financialSettings: 'Paramètres Financiers',
    financialSettingsDesc: 'Configurez vos opérations financières et commerciales',
    selectCurrency: 'Sélectionner la Devise',
    
    // Action buttons
    saveChanges: 'Enregistrer les Modifications',
    saving: 'Enregistrement...',
    savedSuccessfully: 'Enregistré avec Succès',
    errorSaving: 'Erreur d\'Enregistrement',
    
    // Existing translations
    companyInformation: 'Informations de l\'Entreprise',
    companyInformationDesc: 'Informations de base sur votre agence de location de voitures',
    agencyName: 'Nom de l\'Agence',
    agencyNamePlaceholder: 'Entrez le nom de votre agence',
    agencyDescription: 'Description de l\'Agence',
    agencyDescriptionPlaceholder: 'Brève description de votre agence',
    contactInformation: 'Informations de Contact',
    contactInformationDesc: 'Comment les clients peuvent vous joindre',
    phone: 'Numéro de Téléphone',
    phonePlaceholder: 'Entrez le numéro de téléphone',
    email: 'Adresse Email',
    emailPlaceholder: 'Entrez l\'adresse email',
    address: 'Adresse',
    addressPlaceholder: 'Entrez votre adresse',
    city: 'Ville',
    cityPlaceholder: 'Entrez la ville',
    country: 'Pays',
    countryPlaceholder: 'Entrez le pays',
    businessSettings: 'Paramètres d\'Entreprise',
    businessSettingsDesc: 'Configurez vos opérations commerciales',
    currency: 'Devise',
    taxRate: 'Taux de Taxe (%)',
    taxRateHelp: 'Taux de taxe par défaut pour les réservations',
    workingHours: 'Horaires de Travail',
    workingHoursDesc: 'Définissez les heures d\'ouverture de votre agence',
    
    // Company Registration Information
    companyRegistration: 'Enregistrement de l\'Entreprise',
    companyRegistrationDesc: 'Détails légaux d\'enregistrement de l\'entreprise',
    iceNumber: 'Numéro ICE',
    iceNumberPlaceholder: 'Entrez le numéro ICE (Identifiant Commun de l\'Entreprise)',
    rcNumber: 'Numéro RC',
    rcNumberPlaceholder: 'Entrez le numéro RC (Registre de Commerce)',
    ifNumber: 'Numéro IF',
    ifNumberPlaceholder: 'Entrez le numéro IF (Identifiant Fiscal)',
    
    openAlways: 'Ouvert 24h/24 - 7j/7',
    openAlwaysDescription: 'Votre agence est ouverte en continu, 24 heures sur 24 et 7 jours sur 7',
    openAllDay: 'Ouvert Toute la Journée',
    open: 'Ouvert',
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche'
    },
    close: 'Fermer',
    closed: 'Fermé',
    uploadLogo: 'Télécharger le Logo',
    uploadLogoDesc: 'Téléchargez le logo de votre agence (taille recommandée : 200x200px)',
    logoUploaded: 'Logo téléchargé avec succès',
    logoUploadError: 'Échec du téléchargement du logo',
    
    // New notification preferences translations
    emailSettings: 'Paramètres Email',
    emailSettingsDesc: 'Configurez vos préférences de notification par email',
    emailNotifications: 'Notifications Email',
    emailNotificationsDesc: 'Activer ou désactiver toutes les notifications email',
    notificationEmail: 'Email de Notification',
    notificationEmailPlaceholder: 'Entrez l\'email pour les notifications',
    notificationEmailHelp: 'Si vide, les notifications seront envoyées à votre email d\'agence',
    
    bookingNotifications: 'Notifications de Réservation',
    bookingNotificationsDesc: 'Configurez les notifications liées aux réservations',
    bookingPendingConfirmation: 'Confirmation en Attente',
    bookingPendingConfirmationDesc: 'Notifier quand une réservation attend confirmation',
    bookingReturnReminder: 'Rappel de Retour',
    bookingReturnReminderDesc: 'Rappeler aux clients quand leur location se termine',
    bookingOverdueAlerts: 'Alertes de Retard',
    bookingOverdueAlertsDesc: 'Alerter quand un véhicule n\'est pas rendu à temps',
    
    maintenanceAlerts: 'Alertes de Maintenance',
    maintenanceAlertsDesc: 'Notifications de maintenance et conformité des véhicules',
    maintenanceOilChange: 'Rappels de Vidange',
    maintenanceOilChangeDesc: 'Notifier quand les véhicules ont besoin de vidange',
    maintenanceInsuranceExpiry: 'Expiration d\'Assurance',
    maintenanceInsuranceExpiryDesc: 'Alerter quand l\'assurance du véhicule expire',
    maintenanceTechnicalControl: 'Contrôle Technique',
    maintenanceTechnicalControlDesc: 'Rappeler les inspections techniques obligatoires',
    
    timingSettings: 'Paramètres de Timing',
    timingSettingsDesc: 'Configurez quand les notifications sont envoyées',
    pendingConfirmationRemindAfter: 'Rappel de Confirmation',
    pendingConfirmationTimingHelp: 'Minutes après création de réservation pour envoyer le rappel',
    returnReminderBefore: 'Rappel de Retour',
    returnReminderTimingHelp: 'Minutes avant la fin de location pour envoyer le rappel',
    overdueAlertAfter: 'Alerte de Retard',
    overdueAlertTimingHelp: 'Minutes après la fin de location pour envoyer l\'alerte',
    minutes: 'min',
    
    saveNotificationSettings: 'Enregistrer les Paramètres de Notification',
    saveNotificationSettingsDesc: 'Appliquer vos préférences de notification',
    
    notificationPreferences: 'Préférences de Notification',
    notificationPreferencesDesc: 'Configurez vos paramètres de notification',
    advancedNotificationTesting: 'Test du Système de Notification Avancé',
    notificationTestingDesc: 'Testez le système de notification avancé',
    testingFlowDescription: 'Testez le flux complet de notification incluant création de tâches, envoi d\'emails et stockage en base :',
    testingFeatures: {
      emailNotifications: 'Livraison de notifications par email',
      multilingualTemplates: 'Modèles d\'email multilingues',
      jobCreation: 'Création de tâches de notification',
      databaseStorage: 'Stockage et suivi en base de données'
    },
    testingAdvancedNotifications: 'Test du Système...',
    testAdvancedNotificationSystem: 'Tester le Système de Notification Avancé',
    notificationJobsStatus: 'Statut des Tâches de Notification',
    notificationJobsDesc: 'Voir et gérer les tâches de notification',
    noNotificationJobs: 'Aucune tâche de notification pour le moment',
    notificationJobsExplanation: 'Les tâches de notification apparaîtront ici quand vous créerez des réservations ou programmerez la maintenance.',
    notificationsSaved: 'Préférences de notification enregistrées avec succès',

    // Add these new translations for the enhanced notification jobs
    totalJobs: 'Total des Tâches',
    searchJobs: 'Rechercher des tâches...',
    allStatuses: 'Tous les Statuts',
    allTypes: 'Tous les Types',
    pending: 'En Attente',
    executed: 'Exécuté',
    failed: 'Échoué',
    cancelled: 'Annulé',
    bookingReminder: 'Rappel de Réservation',
    maintenanceAlert: 'Alerte de Maintenance',
    insuranceExpiry: 'Expiration d\'Assurance',
    technicalControl: 'Contrôle Technique',
    oilChange: 'Changement d\'Huile',
    noMatchingJobs: 'Aucune tâche correspondante trouvée',
    tryDifferentSearch: 'Essayez d\'ajuster votre recherche ou filtres',
    bookingId: 'ID Réservation',
    carId: 'ID Voiture',
    retries: 'Tentatives',
    created: 'Créé',
    jobData: 'Données de Tâche',
    errorMessage: 'Message d\'Erreur',
    cancelJob: 'Annuler la Tâche',
    retryJob: 'Réessayer la Tâche',
    copyJobId: 'Copier l\'ID de Tâche',
    jobCancelled: 'Tâche annulée avec succès',
    jobCancelError: 'Erreur lors de l\'annulation de la tâche',
    jobRetried: 'Tâche programmée pour une nouvelle tentative',
    jobRetryError: 'Erreur lors de la nouvelle tentative de la tâche',
    jobIdCopied: 'ID de tâche copié dans le presse-papiers',
    showingJobs: 'Affichage de {{start}}-{{end}} sur {{total}} tâches',
    status: {
      pending: 'En Attente',
      executed: 'Exécuté',
      failed: 'Échoué',
      cancelled: 'Annulé'
    },
    
    // Username & URL translations
    usernameAndUrl: {
      title: 'Nom d\'utilisateur et URL de l\'Agence',
      description: 'Définissez votre nom d\'utilisateur personnalisé pour obtenir un sous-domaine professionnel comme YourUsername.kiracar.com sur lequel les clients peuvent cliquer pour visiter votre agence',
      subdomainUrl: 'URL de votre Sous-domaine',
      new: 'NOUVEAU',
      clickToVisit: 'Cliquez pour visiter votre sous-domaine • Redirige vers votre page d\'agence principale',
      copy: 'Copier',
      username: 'Nom d\'utilisateur',
      usernameRequirements: '3-50 caractères, lettres, chiffres et tirets uniquement',
      usernamePlaceholder: 'nom-de-votre-agence',
      subdomainPreview: 'Votre sous-domaine : {{slug}}.kiracar.com',
      subdomainPreviewDesc: 'Cliquez pour visiter • Redirige automatiquement vers votre page d\'agence',
      generate: 'Générer',
      suggestions: 'Suggestions :',
      saveUsername: 'Enregistrer le Nom d\'utilisateur',
      benefitsTitle: 'Avantages de Votre Sous-domaine Personnalisé',
      benefit1: 'Sous-domaine professionnel (ex. : YourAgency.kiracar.com)',
      benefit2: 'Lien cliquable qui s\'ouvre dans un nouvel onglet',
      benefit3: 'Plus facile pour les clients de se souvenir et de partager',
      benefit4: 'Parfait pour les cartes de visite et les supports marketing',
      benefit5: 'Meilleur référencement et visibilité dans les recherches',
      benefit6: 'Redirection automatique vers votre page d\'agence',
      subdomainUrlCopied: 'URL du sous-domaine copiée dans le presse-papiers !',
      agencyUrlCopied: 'URL de l\'agence copiée dans le presse-papiers !',
      usernameUpdatedSuccess: 'Nom d\'utilisateur mis à jour avec succès !',
      usernameUpdateFailed: 'Échec de la mise à jour du nom d\'utilisateur',
      testType: 'Type de Test',
      selectTestType: 'Sélectionner le type de test',
      basicEmailServiceTest: 'Test de Service Email de Base',
      bookingNotificationTest: 'Test de Notification de Réservation',
      maintenanceAlertTest: 'Test d\'Alerte de Maintenance',
      enableEmailToTest: 'Activez les notifications par email pour tester le système',
      testSuccessful: 'Test Réussi !',
      testFailed: 'Test Échoué',
      testEmailSentSuccess: 'Email de test envoyé avec succès ! ID du message : {{messageId}}',
      testEmailSendFailed: 'Échec de l\'envoi de l\'email de test',
      testEmailError: 'Une erreur s\'est produite lors du test du service email',
    },
  },

  // Dashboard analytics
  bookingStatus: 'Statut des réservations',
  
  // Common translations  
  view: 'Voir',
  close: 'Fermer',
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  save: 'Enregistrer',
  
  // Missing unique translations for BookingTimelineCalendar only
  invalidFormat: 'Format invalide',
  dateError: 'Erreur de date',
  notSpecified: 'Non spécifié',
  noVehicleFoundFor: 'Aucun véhicule trouvé pour',
  noVehicleFound: 'Aucun véhicule trouvé',
  showing: 'Affichage',
  to: 'à',
  of: 'de',
  rowsPerPage: 'Lignes par page',
  previous: 'Précédent',
  next: 'Suivant',
  idNumber: 'Numéro d\'identité',
  phoneLabel: 'Téléphone',
  vehicleNotFound: 'Véhicule non trouvé',
  selectStatus: 'Sélectionner statut',
  selectDate: 'Sélectionner date',
  selectTime: 'Sélectionner heure',
  calendarVehicles: 'Véhicules',
  calendarUnknownClient: 'Client inconnu',
  calendarBookingDetails: 'Détails de la Réservation',
  calendarEdit: 'Modifier',
  calendarCancel: 'Annuler',
  calendarSaving: 'Enregistrement...',
  calendarSave: 'Enregistrer',
  calendarCustomerInformation: 'Informations Client',
  calendarVehicle: 'Véhicule',
  calendarSelectVehicle: 'Sélectionner véhicule',
  calendarStatus: 'Statut',
  calendarConfirmed: 'Confirmé',
  calendarPending: 'En attente',
  calendarCompleted: 'Complété',
  calendarCancelled: 'Annulé',
  calendarStartDate: 'Date de début',
  calendarPickupTime: 'Heure de prise',
  calendarEndDate: 'Date de fin',
  calendarReturnTime: 'Heure de retour',
  calendarPickupLocation: 'Lieu de prise',
  calendarReturnLocation: 'Lieu de retour',

  notifications: {
    title: 'Notifications',
    markAllAsRead: 'Marquer tout comme lu',
    noNotifications: 'Aucune notification',
    markAsReturned: 'Marquer comme retourné',
    editVehicle: 'Modifier le Véhicule',
    criticalAlerts: 'Alertes Critiques',
    processing: 'Traitement...',
    newNotification: 'Nouvelle notification',
    priority: 'Priorité',
    urgent: 'Urgent',
    important: 'Important',
    normal: 'Normal',
    high: 'Élevé',
    medium: 'Moyen',
    low: 'Faible',
  },

  bookingScheduler: {
    updating: 'Mise à jour...',
    autoSchedulerActive: 'Planificateur automatique actif',
    schedulerRunning: 'Vérification des réservations...',
  },
}; 